<template>
    <button :class="buttonClass" :style="{ padding: buttonPadding }" @click="handleClick">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: 'newButton',
        props: {
            buttonColoring: {
                type: String,
                default: 'blue'
            },
            buttonPadding: {
                type: String,
                default: '17px 40px'
            }
        },
        data() {
            return {
                buttonClass: 'new_button'
            }
        },
        methods: {
            handleClick() {
                this.$emit('click');
            }
        },
        mounted() {
            switch(this.buttonColoring) {
                case 'blue':
                    this.buttonClass += ' blue';
                    break;
                case 'green':
                    this.buttonClass += ' green';
                    break;
            }
        }
    };
</script>

<style scoped>
    .new_button.blue {
        background-color: var(--color-blue);
    }

    .new_button.green {
        background-color: var(--color-green);
    }

    .new_button {
        font-size: 17px;
        font-weight: 500;
        line-height: 21px;

        box-shadow: 4px 4px 0 0 #9ABCD6;
        color: #fff;

        padding: v-bind(buttonPadding);

        border: none;
        cursor: pointer;

        transition: color .3s ease-out, background-color .3s ease-out;
    }

    .new_button:hover {
        color: rgb(23, 74, 139);
        box-shadow: 2px 2px #9ABCD6;
        background-color: #A0C084;
    }
</style>
